import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './app/app';
import * as serviceWorker from './serviceWorker';
import ErrorBoundary from './app/components/utils/error-boundary';
import { Provider as ReduxProvider } from 'react-redux';
import store from './app/logic/redux/store';

// console.log('PROCESS.ENV: ', process.env);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn:
      'https://da05046b2418d82d62a6355964e0d683@o4509237083701248.ingest.de.sentry.io/4510822737641552',
    environment: process.env.REACT_APP_DEPLOYMENT
      ? process.env.REACT_APP_DEPLOYMENT
      : 'local-build',
    release: process.env.REACT_APP_RELEASE_VERSION,
  });
}

ReactDOM.render(
  <>
    <ErrorBoundary>
      <ReduxProvider store={store}>
        <App />
      </ReduxProvider>
    </ErrorBoundary>
  </>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
